<template>
  <!-- <div class="flex h-full w-full bg-img vx-row no-gutter items-center justify-center" id="page-forgot-password"> -->
  <div class="flex custom-auth-page">
    <template v-if="isDesktop">
      <span class="title-video"></span>
      <div class="video-back"></div>
      <div class="w-full h-100 video-container">
        <video autoplay muted loop>
          <source src="@/assets/video/video_safras.mp4" type="video/mp4" />
        </video>
      </div>
    </template>
    <div
      class="flex vx-row items-center justify-center bg-auth"
      :class="{ 'w-full no-gutter': !isDesktop, 'h-screen': !fromPopup }"
      id="page-login"
    >
      <!-- <div class="mobile-btn-back">
        <button v-if="!isDesktop" @click="onClose" class="btn-close">
          <feather-icon icon='XIcon'/>
        </button>
      </div> -->
      <vs-popup
        :title="$t('HELP_PRIVACY_POLICY').Title"
        :active.sync="displayPopupPrivacyPolicy"
        class="privacy-policy-modal"
        :class="{ 'privacy-policy-modal-mobile': !isDesktop }"
      >
        <privacy-policy v-if="displayPopupPrivacyPolicy"></privacy-policy>
      </vs-popup>
      <vs-popup
        :title="$t('TERMS_USE').Title"
        :active.sync="displayPopupTermsCondition"
        class="terms-condition-modal"
        :class="{ 'terms-condition-modal-mobile': !isDesktop }"
      >
        <terms-use
          :displayActionButton="false"
          v-if="displayPopupTermsCondition"
        ></terms-use>
      </vs-popup>
      <div class="h-full">
        <VuePerfectScrollbar
          class="auth-content-scroll h-full"
          :settings="settings"
          :suppressScrollX="true"
        >
          <div class="items-center w-full login-cont">
            <div slot="no-body" class="full-page-bg-color">
              <div class="login-body">
                <div
                  class="vx-col lg:block lg:w-1/1 mx-auto self-center logo-click"
                  style="text-align: center"
                  @click="onClose"
                >
                  <span class="back-login-button" v-if="!fromPopup">
                    <feather-icon icon="XIcon" svgClasses="w-6 h-6" />
                  </span>
                  <vx-tooltip
                    :text="$t('LOGIN').Click_Back"
                    position="bottom"
                    delay=".1s"
                  >
                    <div
                      class="logo-login mx-auto"
                      :class="{ 'logo-login-mobile': !isDesktop }"
                    ></div>
                  </vx-tooltip>
                  <!-- <img src="@/assets/images/pages/login/padlock.svg" alt="login" class="mx-auto" v-if="isDesktop"> -->
                  <!-- <div class="logo-login mx-auto logo-login-mobile" v-if="!isDesktop"></div> -->
                </div>
                <div class="w-full center">
                  <h3 class="mb-6">{{ $t("FORGOT_PASSWORD").RecoverTitle }}</h3>
                </div>
                <div class="pagecard">
                  <!-- <vs-button type="flat" @click="onBack">Voltar</vs-button> -->
                  <div v-if="showForm">
                    <div class="mb-2">
                      {{ $t("FORGOT_PASSWORD").RecoverDesc }}
                    </div>

                    <div class="mt-2 mb-2">
                      <vs-input
                        id="email"
                        type="email"
                        v-validate="'required|email'"
                        name="email"
                        :label="$t('FORGOT_PASSWORD').Field_Email"
                        v-model="email"
                        class="w-full"
                        icon="icon-mail"
                        icon-pack="feather"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('email')"
                        >{{ errors.first("email") }}</span
                      >
                      <!-- <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">{{$t('BUTTONS').BackLogin}}</vs-button> -->
                    </div>

                    <div class="flex flex-row-reverse mt-3 mb-3">
                      <vs-button @click="onSubmit" class="btn-login">{{
                        $t("BUTTONS").RecoverButton
                      }}</vs-button>
                    </div>
                    <auth-links
                      :fromPopup="fromPopup"
                      :login="false"
                      :register="false"
                      :lostAccess="true"
                      @open-login="$emit('open-login')"
                      @open-lost-access="$emit('open-lost-access')"
                      @open-register="$emit('open-register')"
                    ></auth-links>
                    <!-- <div class="client-pass pr-5 mt-1" style=""> {{ $t('REGISTER').HasAccount }}  <a class="forgot-pass cursor-pointer" @click="openLogin">{{ $t('LOGIN').Click_Here }}</a></div> -->
                    <!-- <div class="flex flex-row-reverse">
                    <vs-button class="vs-component vs-button btn-login vs-button-primary vs-button-filled" @click="onSubmit">
                      {{$t('BUTTONS').RecoverButton}}
                    </vs-button>
                  </div> -->
                  </div>
                  <div class="" v-else>
                    <div class="vx-card__title mb-3">
                      <h4 class="pt-5 mb-4">
                        {{ $t("FORGOT_PASSWORD").EmailSent }}
                      </h4>
                      <p>{{ $t("FORGOT_PASSWORD").CheckEmail }}</p>
                    </div>
                  </div>
                </div>
                <auth-footer-privacy
                  @open-terms="
                    displayPopupTermsCondition = !displayPopupTermsCondition
                  "
                  @open-privacy="
                    displayPopupPrivacyPolicy = !displayPopupPrivacyPolicy
                  "
                ></auth-footer-privacy>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import userService from "../../providers/userService";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import AppConstants from "../../appConstants";
import AuthFooterPrivacy from "./AuthFooterPrivacy.vue";
import TermsUse from "./help/TermsUse.vue";
import PrivacyPolicy from "./help/PrivacyPolicy.vue";
import AuthLinks from "./AuthLinks.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Typewriter from "t-writer.js";
import router from "@/router";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";

export default {
  props: {
    fromPopup: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AuthFooterPrivacy,
    TermsUse,
    PrivacyPolicy,
    AuthLinks,
    VuePerfectScrollbar,
  },
  data() {
    return {
      showForm: true,
      email: "",
      displayPopupTermsCondition: false,
      displayPopupPrivacyPolicy: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true,
      },
    };
  },
  mounted() {
    if (this.isDesktop) {
      const target = document.querySelector(".title-video");
      // console.log(target);
      const options = {
        loop: true,
        typeColor: "white",
        typeSpeed: 80,
        deleteSpeed: 10,
      };

      const writer = new Typewriter(target, options)
        .changeCursorColor("white")
        .type(
          "Safras & Mercado: A sua casa de análises do Brasil e América Latina"
        )
        .rest(30000000)
        .clear()
        .start();
    }
    const emailStore = this.getEmailFromStore();
    if (emailStore) {
      this.email = "";
    }
    document.getElementById("email").focus();

    if (this.$store.state.insetTop) {
      document.querySelector(".full-page-bg-color").style.top =
        this.$store.state.insetTop + "px";
    }

    if (this.$store.state.insetBottom) {
      document.querySelector(".full-page-bg-color").style.bottom =
        this.$store.state.insetBottom + "px";
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    },
  },
  methods: {
    openLogin() {
      router.push({ path: checkDeviceTypeHelper.getUrlLogin() });
    },
    onBack() {
      this.$emit("back");
    },
    onClose() {
      if (this.fromPopup) {
        this.$emit("close");
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
    },
    getEmailFromStore() {
      return localStorage.email;
    },
    sendEmail() {
      userService
        .forgotPassword(
          { email: this.email.toLowerCase() },
          new URLSearchParams()
        )
        .then(() => {
          this.showForm = false;
          messagesNotifyHelper.successNotify(
            this.$t("FORGOT_PASSWORD").Notify_Success_Title,
            this.$t("FORGOT_PASSWORD").Notify_Success_Message
          );
        })
        .catch((error) => console.log(error));
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendEmail();
        } else {
          messagesNotifyHelper.errorNotify(
            this.$t("FORGOT_PASSWORD").Notify_Error_Title,
            this.$t("FORGOT_PASSWORD").Notify_Error_Message
          );
        }
      });
    },
  },
};
</script>
